import { render, staticRenderFns } from "./AuthorList.vue?vue&type=template&id=54045294&scoped=true"
import script from "./AuthorList.vue?vue&type=script&lang=js"
export * from "./AuthorList.vue?vue&type=script&lang=js"
import style0 from "./AuthorList.vue?vue&type=style&index=0&id=54045294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54045294",
  null
  
)

export default component.exports